var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsJ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 20,
    viewBox: "0 0 101 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.364 9.51487C37.0316 11.8861 33.9296 18.8409 32.1641 17.7252C19.3649 9.63704 5.90346 11.724 4.45892 11.3369C3.01437 10.9499 -3.56131 6.59973 5.1782 4.80038C13.9177 3.00102 31.0296 6.55084 34.364 9.51487Z",
    className: "Brows"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5381 4.9254C75.6594 5.88105 69.0951 7.79642 67.1618 9.51487C64.4942 11.8861 67.5963 18.8409 69.3618 17.7252C74.5067 14.474 79.7587 12.8669 84.2941 12.0823C84.4866 9.92985 83.4625 6.98208 82.5381 4.9254ZM86.9584 11.6996C87.4076 9.62769 86.725 6.41186 85.7094 4.55762C86.5757 4.4777 87.4365 4.41585 88.2831 4.37437C89.173 6.24079 90.2831 9.14524 90.3169 11.4263C89.2814 11.477 88.1556 11.5618 86.9584 11.6996ZM93.0208 11.3582C93.841 11.3556 94.5591 11.3682 95.158 11.3786C95.3967 11.3828 95.6165 11.3867 95.8162 11.3891C95.7716 9.14094 94.6944 6.29958 93.8149 4.44147C93.0979 4.3781 92.3484 4.33921 91.5745 4.32263C92.6075 6.0363 93.3482 9.19249 93.0208 11.3582ZM97.4641 5.06579C98.1709 6.60236 98.6563 8.77 98.5937 10.5444C100.574 9.20184 102.828 6.53755 97.4641 5.06579Z",
    className: "Brows"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsJ);
export default __webpack_public_path__ + "static/media/Brows J.b1d17fbdf1e2e31744436ec2154bd96a.svg";
export { ForwardRef as ReactComponent };